import { Injectable } from '@angular/core';
import {ParentService} from '../../A2-utils/ParentClass/ParentService';
import {Router} from '@angular/router';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {constant} from '../../../app.constants';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class RiderNotesService extends ParentService {
    constructor(private http: Http, private route: Router) {
        super();
        // this.verifyToken(this.http, route);
    }

    /**
     * @description
     * @param id
     * @returns {any}
     */
    public getRiderNote(id) {
        return this.http.get(constant.URL_RIDER_NOTES + '/' + id, this.getHeader())
            .map(resp => resp.json());
    }

    /**
     * @description\
     * @returns {Observable<any>}
     */
    public getUserAll() {
        return this.http.get(constant.URL_USER_PROFILE_ALL, this.getHeader())
            .map(resp => resp.json());
    }

    /**
     * @description
     * @param data
     * @returns {Observable<any>}
     */
    public deleteRiderNote(data){
        return this.http.delete(constant.URL_RIDER_NOTES + '/' + data, this.headerPost())
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json()));
    }

    /**
     * @description
     * @param data
     * @returns {Observable<any>}
     */
    public postRiderNote(data: any) {
        const bodyString = JSON.stringify(data);
        return this.http.post(constant.URL_RIDER_NOTES, bodyString, this.headerPost())
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json()));
    }

    /**
     * @description
     * @param data
     * @returns {Observable<any>}
     */
    public putRiderNote(data) {
        const bodyString = JSON.stringify(data);
        return this.http.put(constant.URL_RIDER_NOTES, bodyString, this.headerPost())
            .map((res: Response) => res.json())
            .catch((error: any) => Observable.throw(error.json()));
    }

    /**
     * @description
     * @param id
     * @returns {Observable<any>}
     */
    public getRiderNotes(id) {
        return this.http.get(constant.URL_RIDER_NOTES + '/list/' + id, this.getHeader())
            .map(resp => resp.json());
    }


}



// WEBPACK FOOTER //
// ./src/app/pages/riders/rider-notes/rider-notes.service.ts